module.exports = __webpack_public_path__ + "img/AFMS_MB_RN.f1c5ee93.png";